/* eslint-disable no-restricted-syntax */
/* eslint-disable padded-blocks */
/* eslint-disable nonblock-statement-body-position */
/* eslint-disable import/no-cycle */
import { map, uniqBy } from "lodash";

import { nowUtcDate } from "../tools/date-utils";
import getConverstionMessages, {
  markAsReadMessages,
  markAsNotReadMessage,
  getNotSeenMessages,
  getLastMessageId,
  getFollowUpMessageQuery,
  createFollowUpMessageQuery,
  deleteMessage,
  getFollowUpMessageQueryEdit,
  updateFollowUpMessageQuery,
  deleteFollowUpMessageQuery,
  getLastActiveWindow
} from "../utils/getMessages";
import {
  SET_CONVERSATIONS,
  SET_CONVERSATION_AS_SELECTED,
} from "./conversationsDuck";
import CONSTANTS from "../const/constants";
import { getConversationByKey } from "../utils/getConversations";
import {
  getConversationPlatformName,
  getWindowRemainingMinutes,
  latestTimestamp,
  usesCustomerMessageWindow,
} from "../utils/messageWindow";
const MESSAGES_INITIAL_STATE = {
  data: [],
  selectedMessages: [],
  selectedToReply: null,
  fetched: false,
  fetching: false,
  error: false,
  isSelectionActive: false,
  fetchingMoreMessages: false,
  fetchingNewMessage: false,
  fetchedNewMessageError: false,
  showNewMessagesButton: false,
  isScrollMessagesBottom: true,
  lastMessageCursor: 0,
  forwardingSuccess: false,
  isSMSShowed: true,
  isWAShowed: true,
  windowRemaining: 0,
  // Conversation whose window was last derived and the time of its customer's
  // last message, in epoch milliseconds (null when the customer never wrote).
  // Every writer of `windowRemaining` needs it to apply the same rule.
  windowLastClientMessage: null,
};

let isFirstMessage = true;

// constants
const SET_MESSAGES = "SET_MESSAGES";
const SET_MESSAGES_SELECTION_ACTIVE = "SET_MESSAGES_SELECTION_ACTIVE";
const SET_MESSAGES_SELECTION_DISABLED = "SET_MESSAGES_SELECTION_DISABLED";
export const ADD_NEW_MESSAGES = "ADD_NEW_MESSAGES";
const GET_MESSAGES = "GET_MESSAGES";
const GET_MESSAGES_SUCCESS = "GET_MESSAGES_SUCCESS";
const GET_MESSAGES_ERROR = "GET_MESSAGES_ERROR";
const GET_MESSAGES_ABANDONED = "GET_MESSAGES_ABANDONED";
const HANDLE_NEW_MESSAGES_BUTTON = "HANDLE_NEW_MESSAGES_BUTTON";
const ADD_NEW_MESSAGE_TO_CURSOR = "ADD_NEW_MESSAGE_TO_CURSOR";
const CLEAR_MESSAGES = "CLEAR_MESSAGES";
const SET_CURSOR = "SET_CURSOR";
const CLEAR_DATA = "CLEAR_DATA";
const SET_F0RWARDING_SUCCESS = "SET_F0RWARDING_SUCCESS";
const UPDATE_MESSAGE_STATUS = "UPDATE_MESSAGE_STATUS";
const SET_MESSAGE_TO_REPLY = "SET_MESSAGE_TO_REPLY";
const SET_IS_SMS_SHOWED = "SET_IS_SMS_SHOWED";
const SET_IS_WA_SHOWED = "SET_IS_SMS_SHOWED";
const UNSET_MESSAGE_TO_REPLY = "UNSET_MESSAGE_TO_REPLY";
const SET_WINDOW_REMAINING_TIME = "SET_WINDOW_REMAINING_TIME"
const SET_WINDOW_LAST_CLIENT_MESSAGE = "SET_WINDOW_LAST_CLIENT_MESSAGE";
// reducer
export default function messagesReducer(
  state = MESSAGES_INITIAL_STATE,
  action
) {
  const { type, payload } = action;
  switch (type) {
    case SET_MESSAGES:
      return payload;
    case ADD_NEW_MESSAGES:
      return { ...state, data: payload };
    case UPDATE_MESSAGE_STATUS:
      return { ...state, data: payload };
    case GET_MESSAGES:
      return { ...state, fetching: true, error: false };
    case GET_MESSAGES_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: false,
        data: payload.messages,
        lastMessageCursor: payload.lastMessageCursor,
        selectedMessages: payload.selectedMessages,
      };
    case GET_MESSAGES_ERROR:
      // The history could not be loaded: the view offers a retry instead of
      // showing the conversation as empty. The thunk logs the error itself.
      return { ...state, fetching: false, error: true };
    case GET_MESSAGES_ABANDONED:
      // The latest load ended for a conversation that is no longer open:
      // nothing of it is written, only the loader goes away.
      return { ...state, fetching: false };
    case HANDLE_NEW_MESSAGES_BUTTON:
      return { ...state, showNewMessagesButton: payload };
    case ADD_NEW_MESSAGE_TO_CURSOR:
      return { ...state, lastMessageCursor: state.lastMessageCursor + 1 };
    case SET_CURSOR:
      return { ...state, lastMessageCursor: 0 };
    case CLEAR_MESSAGES:
      return { ...MESSAGES_INITIAL_STATE };
    case CLEAR_DATA:
      return { ...MESSAGES_INITIAL_STATE };
    case SET_MESSAGES_SELECTION_ACTIVE:
      return {
        ...state,
        isSelectionActive: true,
        selectedMessages: payload.selectedMessages,
      };
    case SET_IS_SMS_SHOWED:
      return {
        ...state,
        isSMSShowed: payload.isSMSShowed,
        isWAShowed: payload.isWAShowed,
      };
    case SET_WINDOW_REMAINING_TIME:
        return {
          ...state,
          windowRemaining: payload.windowRemaining,
        };
    case SET_WINDOW_LAST_CLIENT_MESSAGE:
      return { ...state, windowLastClientMessage: payload };
    case SET_IS_WA_SHOWED:
      return {
        ...state,
        isWAShowed: payload.isWAShowed,
        isSMSShowed: payload.isSMSShowed,
      };
    case SET_MESSAGES_SELECTION_DISABLED:
      return { ...state, isSelectionActive: false, selectedMessages: [] };
    case SET_F0RWARDING_SUCCESS:
      return { ...state, forwardingSuccess: true, selectedMessages: [] };
    case SET_MESSAGE_TO_REPLY:
      return { ...state, selectedToReply: payload };
    case UNSET_MESSAGE_TO_REPLY:
      return { ...state, selectedToReply: null };
    default:
      return state;
  }
}

// actions

export const setMessageToReplyAction = (id) => (dispatch, getState) => {
  const message = getState().messages.data.filter(
    (message) => message.id === id
  )[0];
  dispatch({ type: SET_MESSAGE_TO_REPLY, payload: message });
};

export const unsetMessageToReplyAction = () => (dispatch) => {
  dispatch({ type: SET_MESSAGE_TO_REPLY });
};

export const setMessagesSelectionActive = (status) => (dispatch) => {
  dispatch({ type: SET_MESSAGES_SELECTION_ACTIVE, payload: status });
};

export const setMessagesSelectionDisabled = (status) => (dispatch) => {
  dispatch({ type: SET_MESSAGES_SELECTION_DISABLED, payload: status });
};

export const setMessagesAction = (messages) => ({
  type: SET_MESSAGES,
  payload: messages,
});

export const setIsMsgShowed =
  (isWAShowed, isSMSShowed) => async (dispatch, getState) => {
    console.log("ON CLICK setIsMsgShowed => ", isWAShowed, isSMSShowed);

    await dispatch({
      type: SET_IS_WA_SHOWED,
      payload: { isWAShowed: isWAShowed, isSMSShowed: isSMSShowed },
    });
    await dispatch(getMessagesAction(false));
  };

export const setIsSMSMsgShowed = (isShowed) => async (dispatch, getState) => {
  console.log("ON CLICK setIsSMSMsgShowed => ", isShowed);

  //await dispatch({ type: SET_IS_SMS_SHOWED, payload: { isSMSShowed:isShowed } });
  //await  dispatch(getMessagesAction(false));
};

export const handleNewMessagesButtonAction = (status) => (dispatch) => {
  dispatch({ type: HANDLE_NEW_MESSAGES_BUTTON, payload: status });
};

/**
 * The `lastMessage` a conversation-list row shows for a message the agent
 * just sent. `conversationCard` reads `content || text`, `createdAt` and
 * `sender`; the message id is kept so `updateMessageId` can find the row when
 * the server answers.
 */
const toRowLastMessage = (message) => ({
  ...message,
  content: message.content ?? message.text ?? "",
  createdAt: message.createdAt ?? nowUtcDate().toISOString(),
});

/**
 * The `lastMessage` of a row whose send failed in this client. `sent` and
 * `error` are the flags the bubble has always carried. `messageStatus:
 * "failed"` is the status the server reports for a message it could not
 * deliver, the one `MessageViewed` paints with its error mark on the row: an
 * absent status reads there as the single "sent" check, so the row needs it
 * spelled out (the bubble turns red by `error` and does not).
 */
const toFailedRowLastMessage = (lastMessage) => ({
  ...lastMessage,
  sent: false,
  error: true,
  messageStatus: "failed",
});

/**
 * True for a row's last message marked by `toFailedRowLastMessage`. That
 * failure is this client's reading of its own request, not a status the
 * server reported — copies that come from the server never carry `sent: false`
 * — so `updateMessageStatus` lets the server's word replace it.
 */
export const isLocalSendFailure = (lastMessage) =>
  lastMessage?.error === true && lastMessage?.sent === false;

export const updateMessageId =
  (previousId, message) => (dispatch, getState) => {
    const newMessages = getState().messages.data.map((x) => {
      if (x.id === previousId) {
        return { ...message, sent: true };
      } else {
        return { ...x };
      }
    });
    const messagesUniq = uniqBy(newMessages, "id");
    dispatch({ type: ADD_NEW_MESSAGES, payload: messagesUniq });

    // `sendNewMessageAction` wrote the row (and `current`) with the optimistic
    // id; swap in the server copy without losing the row's own fields.
    let updateConversations = false;
    const newConversations = [...(getState().conversations?.data || [])].map(
      (x) => {
        if (x?.lastMessage?.id !== previousId) return { ...x };
        updateConversations = true;
        return {
          ...x,
          lastMessage: toRowLastMessage({
            ...x.lastMessage,
            ...message,
            sent: true,
          }),
        };
      }
    );
    if (!updateConversations) return;

    const { current, isCurrentWindowOpen } = getState().conversations;
    if (current?.lastMessage?.id !== previousId) {
      dispatch({ type: SET_CONVERSATIONS, payload: newConversations });
      return;
    }
    dispatch({
      type: SET_CONVERSATION_AS_SELECTED,
      payload: {
        data: newConversations,
        current: {
          ...current,
          lastMessage: toRowLastMessage({
            ...current.lastMessage,
            ...message,
            sent: true,
          }),
        },
        isCurrentWindowOpen,
      },
    });
  };
export const updateMessageStatusId =
  (previousId, messageStatus, messages, errorCode = null, errorInfo = null) =>
  (dispatch) => {
    const messagesS = [...messages];
    const messageToUpdateIndex = messages.findIndex((x) => x.id === previousId);
    messagesS[messageToUpdateIndex].messageStatus = messageStatus;
    messagesS[messageToUpdateIndex].errorCode = errorCode;
    messagesS[messageToUpdateIndex].errorInfo = errorInfo;
    dispatch({ type: UPDATE_MESSAGE_STATUS, payload: messagesS });
  };

export const updateMessageWithError = (id) => (dispatch, getState) => {
  const messages = [...getState().messages.data];
  const messageToUpdateIndex = messages.findIndex((x) => x.id === id);
  messages[messageToUpdateIndex] = {
    ...messages[messageToUpdateIndex],
    sent: false,
    error: true,
  };
  console.log("2");
  dispatch({ type: ADD_NEW_MESSAGES, payload: messages });

  // `sendNewMessageAction` also put this message on the conversation's row.
  // Left alone, the row keeps showing the failed text next to the "sent"
  // check, so the row is marked too. Keyed by the message id: a row that
  // already moved on to a newer message (another send, a Pusher event) is left
  // alone, and a row without a last message never matches an absent id.
  //
  // `current` is not rewritten. Nothing paints its `lastMessage`, it travels
  // to the backend as `client` on the next send, and a new `current` object
  // re-runs the effects that watch it (composer, client form) at whatever
  // moment the failure lands.
  const conversations = getState().conversations?.data || [];
  const showsIt = (conversation) =>
    !!id && conversation?.lastMessage?.id === id;
  if (!conversations.some(showsIt)) return;
  dispatch({
    type: SET_CONVERSATIONS,
    payload: conversations.map((x) =>
      showsIt(x)
        ? { ...x, lastMessage: toFailedRowLastMessage(x.lastMessage) }
        : x
    ),
  });
};

export const selectingMessagesAction =
  (messageIds) => async (dispatch, getState) => {
    try {
      const messages = getState().messages.data;
      const currentSelectedMessages = getState().messages.selectedMessages;

      for (const messageId of messageIds) {
        const index = currentSelectedMessages.indexOf(messageId);
        if (index === -1) currentSelectedMessages.push(messageId);
        else currentSelectedMessages.splice(index, 1);
      }

      for (const message of messages) {
        message.selected = currentSelectedMessages.some(
          (id) => message.messageApiId === id
        );
      }

      dispatch({
        type: SET_MESSAGES_SELECTION_ACTIVE,
        payload: { selectedMessages: currentSelectedMessages },
      });
    } catch (error) {
      console.log(error);
    }
  };

export const addLastMessageAction = (lastMessage) => (dispatch, getState) => {
  const messages = [...getState().messages.data];
  const userId = getState().user.data.id;
  if (isFirstMessage) {
    isFirstMessage = false;
  } else {
    isFirstMessage = true;
  }

  if (lastMessage.senderId !== userId) {
    dispatch(handleNewMessagesButtonAction(true));
  }

  if (messages[0]?.id === lastMessage.id) {
    const lastMessageData = { ...lastMessage, sent: true };
    messages.splice(0, 1, lastMessageData);
    console.log("3");
    dispatch({ type: ADD_NEW_MESSAGES, payload: messages });
  } else {
    const lastMessageData = { ...lastMessage, sent: true };
    messages.unshift(lastMessageData);
    console.log("4");
    dispatch({ type: ADD_NEW_MESSAGES, payload: messages });
    // dispatch({ type: ADD_NEW_MESSAGE_TO_CURSOR });
  }
};

export const deleteMessageAction = (id) => async (dispatch, getState) => {
  await deleteMessage(id);
  const messages = [...getState().messages.data];
  const newMessages = messages.filter((x) => x.id !== id);
  console.log("5");
  dispatch({ type: ADD_NEW_MESSAGES, payload: newMessages });
};

export const getMessagesLoaderAction = () => (dispatch) => {
  dispatch({ type: GET_MESSAGES });
};

export const resetCursorAction = () => (dispatch) => {
  dispatch({ type: SET_CURSOR, payload: 0 });
};

// Each window read gets a sequence number so that only the most recent one
// may write to the store. The agent can switch conversations while a read is
// in flight (even A → B → A), and two reads of the same conversation (one on
// the id change, one on the client's first message) can answer in reverse
// order; a late answer would put the banner back in a wrong state until the
// next refresh.
let latestWindowRequestId = 0;

// Time of the customer's last message of `clientId` as the state knows it:
// epoch milliseconds, null when the customer never wrote, and undefined while
// the window of that conversation has not been read yet.
const getKnownClientMessageTimestamp = (state, clientId) => {
  const known = state.messages?.windowLastClientMessage;
  return known?.clientId === clientId ? known.timestamp : undefined;
};

export const setWindowRemainingTimeAction = (clientId) => async (dispatch, getState) => {
  if (!clientId) return;

  latestWindowRequestId += 1;
  const requestId = latestWindowRequestId;
  // The answer is applied only while this is still the latest read and the
  // conversation it asked for is still the open one.
  const isCurrent = () =>
    requestId === latestWindowRequestId &&
    getState().conversations?.current?.id === clientId;

  let lastActiveWindow;
  try {
    lastActiveWindow = await getLastActiveWindow(clientId);
  } catch (error) {
    // The read failed: keep whatever the banner shows rather than painting
    // the window as closed on a transient error.
    console.error('GETTING LAST WINDOW FAILED => ', error);
    return;
  }
  if (!isCurrent()) return;

  // A customer message that arrived live can be newer than the one the read
  // answers with; what is known about it only moves forward.
  const lastClientMessageAt = latestTimestamp(
    lastActiveWindow?.lastClientMessageAt,
    getKnownClientMessageTimestamp(getState(), clientId)
  );
  const currentTimestamp = new Date().getTime();
  console.log('currentTimestamp => ', currentTimestamp)

  const windowRemaining = getWindowRemainingMinutes({
    lastClientMessageAt,
    expiration: lastActiveWindow?.windowExpiration,
    platformName: getConversationPlatformName(getState().conversations?.current),
    now: currentTimestamp,
  });
  console.log('diffMinutes => ', windowRemaining)

  dispatch({
    type: SET_WINDOW_LAST_CLIENT_MESSAGE,
    payload: { clientId, timestamp: lastClientMessageAt },
  });
  dispatch({
    type: SET_WINDOW_REMAINING_TIME,
    payload: {
      windowRemaining: windowRemaining,
    },
  });
}

// A customer message that arrives live on the open conversation is its
// customer's last message: remember it so that a status event landing before
// the next window read already counts the 24 hours from it.
export const setWindowLastClientMessageAction = (clientId, createdAt) => (dispatch, getState) => {
  const known = getKnownClientMessageTimestamp(getState(), clientId);
  const latest = latestTimestamp(createdAt, known);
  if (latest === null || latest === known) return;

  dispatch({
    type: SET_WINDOW_LAST_CLIENT_MESSAGE,
    payload: { clientId, timestamp: latest },
  });
};

// The status events of an outgoing message carry a `windowExpiration` too and
// write the banner of the open conversation. They go through the same rule as
// the window read: that value is often the send time of the message, and on
// its own it painted an open window as closed seconds after the agent wrote.
export const setWindowRemainingFromStatusEventAction = (clientId, expiration) => (dispatch, getState) => {
  const conversation = getState().conversations?.current;
  if (conversation?.id !== clientId) return;

  const platformName = getConversationPlatformName(conversation);
  const lastClientMessageAt = getKnownClientMessageTimestamp(getState(), clientId);
  // The window of this conversation has not been read yet, so the event alone
  // could lower the banner: leave it to the read that follows.
  if (usesCustomerMessageWindow(platformName) && lastClientMessageAt === undefined) return;

  dispatch({
    type: SET_WINDOW_REMAINING_TIME,
    payload: {
      windowRemaining: getWindowRemainingMinutes({
        lastClientMessageAt,
        expiration,
        platformName,
        now: new Date().getTime(),
      }),
    },
  });
};

export const setConstWindowRemainingTimeAction = (windowRemaining) => async (dispatch, getState) => {
  dispatch({
    type: SET_WINDOW_REMAINING_TIME,
    payload: {
      windowRemaining: windowRemaining,
    },
  });
    
}

// Each history load gets a sequence number so that only the most recent one
// may write to the store: the user can open another conversation while a load
// is in flight (even go back and forth to the same one).
let latestMessagesRequestId = 0;

export const getMessagesAction = (widthSkip, currentConversation) => async (dispatch, getState) => {
  // Cursor -1 means the history has no older page. Asking for one is not a
  // load: it must not turn `fetching` on (nothing would turn it off again)
  // nor take a sequence number (the answer of a load still in flight would
  // be dropped as stale).
  if (widthSkip && getState().messages.lastMessageCursor === -1) return;
  latestMessagesRequestId += 1;
  const requestId = latestMessagesRequestId;
  let selectedConversation;
  if (currentConversation) {
    selectedConversation = { ...currentConversation };
  } else {
    selectedConversation = { ...getState().conversations.current };
  }
  const requestedConversationId = selectedConversation?.id;
  // A late answer must not touch another conversation's history: the result
  // (or the failure) is applied only when this is still the latest load and
  // the conversation it asked for is still the open one.
  const isCurrent = () =>
    requestId === latestMessagesRequestId &&
    getState().conversations.current?.id === requestedConversationId;
  // When it is not applied but no newer load took over (the open conversation
  // was closed, or another one opened without a load of its own), nothing
  // else turns `fetching` off and the chat would show its loader forever
  // (spec S16). A newer load owns `fetching` and is left alone.
  const abandon = () => {
    if (requestId === latestMessagesRequestId) {
      dispatch({ type: GET_MESSAGES_ABANDONED });
    }
  };
  try {
    console.log(
      "getMessagesAction!!!!!!!!!!!!!!!!! WA SMS => ",
      getState().messages.isWAShowed,
      getState().messages.isSMSShowed
    );
    isFirstMessage = true;
    dispatch({ type: GET_MESSAGES });

    console.log("Conversation state", getState().conversations.current);
    console.log("Conversation currentConversation", currentConversation);
    const conversationsIds = [];
    if (getState().messages.isWAShowed) {
      conversationsIds.push(selectedConversation?.id);
    }
    
    //if (getState().messages.isSMSShowed) {
      const selectedSpaces = getState().spaces.selected;

      const { channels } = selectedSpaces;
      const smsChannel = channels
        .filter((c) => c?.platform?.name === CONSTANTS.SMS_PLATFORM)
        ?.pop();

      console.log(
        "SMS-CHANNEL SENDERID => ",
        smsChannel,
        selectedConversation?.senderId
      );
      const smsKey = smsChannel?.id + selectedConversation?.senderId;
      console.log(
        "SMS-CHANNEL SENDERID smsKey => ",
        smsChannel,
        selectedConversation?.senderId,
        smsKey
      );

      const conversationSMS = await getConversationByKey(smsKey);
      console.log("conversationSMS => ", conversationSMS);

      if (conversationSMS) conversationsIds.push(conversationSMS?.id);
    //}

    console.log("CONVERATIONSIDS =>>>>>", conversationsIds);

    const currentCursor = widthSkip ? getState().messages.lastMessageCursor : 0;
    console.log("Conversation 2", currentCursor);
    // A newer load can reach the end of the history while the lookup above
    // is pending. That load owns `fetching` and already turned it off.
    if (currentCursor === -1) return;
    console.log("Conversation 3", currentCursor);
    const newMessages = await getConverstionMessages(
      conversationsIds.filter((c) => c),
      currentCursor
    );
    console.log("Conversation 4", newMessages);
    if (!isCurrent()) {
      abandon();
      return;
    }
    // `getConversationMessages` swallows network errors and resolves with
    // `undefined`: that is a failed load, not an empty history.
    if (!Array.isArray(newMessages)) {
      throw new Error("ERROR_GETTING_MESSAGES");
    }
    const seenBy = getState().user.data.name;



    if (
      currentCursor === 0
      // TODO: Test: La conversación puede no ser la misma dado que esta se setea hasta recibir el survey en setConversationAsSelectedAction
      // && selectedConversation?.id === getState().conversations.current?.id
    ) {
      console.log("Conversation 6");
      dispatch({
        type: GET_MESSAGES_SUCCESS,
        payload: {
          messages: (newMessages ?? [])?.map((x) => ({
            ...x,
            sent: true,
            seenBy: x.seenBy || seenBy,
            seenAt: x.seenAt || Date.now(),
            time: x.time && parseInt(`${x.time.toString()}000`, 10),
            selected: false,
          })),
          lastMessageCursor: 30,
          isSelectionActive: getState().messages.isSelectionActive,
          selectedMessages: [...getState().messages.selectedMessages],
          isSMSShowed: getState().messages.isSMSShowed,
          isWAShowed: getState().messages.isWAShowed,
        },
      });
    } else {
    // } else if (
      // selectedConversation?.id === getState().conversations.current?.id
    // ) {
      console.log("Conversation 7");
      const previousMessages = getState().messages.data;
      if (newMessages.length === 0) {
        console.log("Conversation 9");
        dispatch({
          type: GET_MESSAGES_SUCCESS,
          payload: {
            messages: previousMessages,
            lastMessageCursor: -1,
            isSelectionActive: getState().messages.isSelectionActive,
            selectedMessages: [...getState().messages.selectedMessages],
            isSMSShowed: getState().messages.isSMSShowed,
            isWAShowed: getState().messages.isWAShowed,
          },
        });
      } else {
        console.log("Conversation 10");
        dispatch({
          type: GET_MESSAGES_SUCCESS,
          payload: {
            messages: [
              ...previousMessages,
              ...newMessages.map((x) => ({
                ...x,
                sent: true,
                seenBy: x.seenBy || seenBy,
                seenAt: x.seenAt || Date.now(),
                time: x.time && parseInt(`${x.time.toString()}000`, 10),
                selected: false,
              })),
            ],
            isSelectionActive: false,
            lastMessageCursor: currentCursor + newMessages.length,
            selectedMessages: [...getState().messages.selectedMessages],
            isSMSShowed: getState().messages.isSMSShowed,
            isWAShowed: getState().messages.isWAShowed,
          },
        });
      }
    }
    // } else {
    //   dispatch(getMessagesAction(widthSkip));
    // }

    //await setWindowRemainingTime(selectedConversation?.id);

  } catch (error) {
    console.error("GET_MESSAGES_ERROR", error);
    if (!isCurrent()) {
      abandon();
      return;
    }
    dispatch({ type: GET_MESSAGES_ERROR, payload: error });
  } finally {
  }
};

export const seenMessage = (conversation) => async (_, getState) => {
  try {
    const pendingMessages = await getNotSeenMessages(conversation.id);
    const userName = getState().user.data?.name;
    const date = nowUtcDate();
    const pendingIds = map(pendingMessages, (message) => message.id);
    await markAsReadMessages(pendingIds, userName, date, conversation.id);
    // await markAsReadMessages(userName, date, conversation?.id);
  } catch (error) {
    throw error;
  }
};

export const unseenMessage = (conversation) => async () => {
  try {
    const pendingMessage = await getLastMessageId(conversation.id);
    await markAsNotReadMessage(pendingMessage, conversation.id);
  } catch (error) {
    throw error;
  }
};

export const sendNewMessageAction = (lastMessage) => (dispatch, getState) => {
  const messages = [...getState().messages.data];
  const lastMessageData = { ...lastMessage };
  messages.unshift(lastMessageData);
  console.log("6");
  dispatch({ type: ADD_NEW_MESSAGES, payload: messages });

  const currentConversation = { ...getState().conversations.current };
  if (!currentConversation.id) return;

  // The row in `conversations.data` shows the new last message and moves to
  // the top, exactly as a Pusher event does for everyone else — Pusher skips
  // the agent's own sends (`message.senderId === userId`), so this is the only
  // path that can update the list for them. When a search filtered the open
  // conversation out of the list it is inserted: the agent is looking at it.
  // That row is not one the server returned for the current search or
  // filters, so it is flagged and `getConversationsAction` leaves it out of
  // the next page's offset.
  const conversations = [...getState().conversations.data];
  const rowLastMessage = toRowLastMessage(lastMessageData);
  const currentConversationIndex = conversations.findIndex(
    (x) => x.id === currentConversation.id
  );
  const row =
    currentConversationIndex === -1
      ? { ...currentConversation, outsideResults: true }
      : { ...conversations[currentConversationIndex] };
  row.lastMessage = rowLastMessage;
  if (currentConversationIndex !== -1) {
    conversations.splice(currentConversationIndex, 1);
  }
  conversations.unshift(row);

  const payload = {
    data: conversations,
    current: { ...currentConversation, lastMessage: rowLastMessage },
  };
  dispatch({ type: SET_CONVERSATION_AS_SELECTED, payload });
};

export const deleteTemporalMessageAction =
  (messageId) => (dispatch, getState) => {
    const messages = [...getState().messages.data];
    const messageIndex = messages.find((x) => x.id === messageId);
    if (messageIndex !== -1) {
      messages.splice(messageIndex, 1);
    }
    console.log("7");
    dispatch({ type: ADD_NEW_MESSAGES, payload: messages });
  };

export const addLastMessageError = () => (dispatch, getState) => {
  const messages = [...getState().messages.data];
  const lastMessageData = { ...messages[0], error: true };
  messages.splice(0, 1, lastMessageData);
  console.log("8");
  dispatch({ type: ADD_NEW_MESSAGES, payload: messages });
};

export const getFollowUpMessage = (selectedConversationId) => async () => {
  const followUpMessage = await getFollowUpMessageQuery(selectedConversationId);
  return followUpMessage;
};

export const createFollowUpMessage = (
  selectedConversationId,
  agentId,
  content,
  sendAt,
  channelId,
  templateId,
  variables,
  fileId
) => async () => {
  const followUpMessage = await createFollowUpMessageQuery(
    selectedConversationId,
    agentId,
    content,
    sendAt,
    channelId,
    templateId,
    variables,
    fileId
  );
  return followUpMessage;
};

export const followUpMessageUpdate =
  (id, content, sendAt, templateId, clientId, agentId, channelId, variables, fileId) =>
  async () => {
    console.log('variables cero => ', variables)
    const followUpMessage = await updateFollowUpMessageQuery(
      id,
      content,
      sendAt,
      templateId,
      clientId,
      agentId,
      channelId,
      variables,
      fileId
    );
    return followUpMessage;
  };

export const getFollowUpMessageForEdit =
  (selectedConversationId) => async () => {
    const followUpMessage = await getFollowUpMessageQueryEdit(
      selectedConversationId
    );
    return followUpMessage;
  };

// `options.pendingOnly`: see `deleteFollowUpMessageQuery`.
export const deleteFollowUpMessage = (selectedConversationId, options) => async () => {
  const deleteFollowUpMessageQ = await deleteFollowUpMessageQuery(
    selectedConversationId,
    options
  );
  return deleteFollowUpMessageQ;
};

export const clearMessagesAction = () => ({
  type: CLEAR_MESSAGES,
  payload: null,
});
